import { getOptimizelyUserId } from 'utils/experiment';
/**
 * Structures optimizely data for use in additionalOptions
 */
export const withOptimizely = () => ({
    Optimizely: {
        userId: getOptimizelyUserId(),
    },
});
